import ReactLoading from "react-loading";
export const Loader = ({ type, color, height = "46px", width = "46px" }) => {
  return (
    <div className="flex justify-center items-center">
      <ReactLoading type={type} color={color} height={height} width={width} />
    </div>
  );
};
